<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="d-flex gap-16 m-b-16">
    <p class="t1 fw-medium">
      {{ 'Customer card' | trans:'card/add-edit-free-entry-form/customerCard.Label' }}
    </p>
    <div class="tag c-bg-blue-200">{{ card.cardNr }}</div>
  </div>

  <div class="d-flex flex-direction-column gap-24">
    <app-form-control
      label="{{ 'Issuer' | trans:'card/add-edit-free-entry-form/issuer.Label' }}"
      [hasErrors]="hasControlErrors('firmId')"
    >
      <app-select
        class="full-width"
        [options]="issuers() | idAndName:'firmId':'name'"
        [placeholder]="'Select issuer' | trans:'card/add-edit-free-entry-form/issuer.Placeholder'"
        [hasResetOption]="true"
        outputType="number"
        [canUnselect]="true"
        formControlName="firmId"
      />
    </app-form-control>

    <div class="d-flex flex-direction-column gap-16">
      @if (isAdd) {
        <app-form-control
          label="{{ 'Number of free entries' | trans:'card/add-edit-free-entry-form/count.Label' }}"
          [hasErrors]="hasControlErrors('count')"
        >
          <app-stepper formControlName="count" [maxValue]="99" />
        </app-form-control>
      }

      <div class="d-flex gap-12">
        <app-datepicker
          formControlName="validFrom"
          class="w-0 flex-grow-1"
          label="{{ 'Valid from' | trans:'card/add-edit-free-entry-form/validFrom.Label' }}"
          [min]="minValidFrom"
          [hasErrors]="hasControlErrors('validFrom')"
          (valueChanged)="getControl('validUntil').patchValue(null)"
        />

        <app-datepicker
          class="w-0 flex-grow-1"
          label="{{ 'Valid until' | trans:'card/add-edit-free-entry-form/validUntil.Label' }}"
          [hasErrors]="hasControlErrors('validUntil')"
          [min]="getControl('validFrom').value | dayjs"
          formControlName="validUntil"
        />
      </div>
    </div>
  </div>
</form>
